export default __webpack_public_path__ + "static/media/logo-md-768w.1e2d01a1.png";